import { render } from "./TeamWidget.vue?vue&type=template&id=1534df23"
import script from "./TeamWidget.vue?vue&type=script&lang=js"
export * from "./TeamWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__